import i18n, { supportedLocales } from '@/i18n';

export { supportedLocales };

export const routeName = (lang, name) => `${lang}.${name}`;

export function routeTitle(name) {
  return i18n.t(`titles.${name}`);
}
